// Static brand + media constants. Brand identity is code-controlled, not CMS-editable.
export const NAV_LINKS = [
  { label: "Systems", to: "/systems" },
  { label: "Technology", to: "/technology" },
  { label: "Company", to: "/company" },
  { label: "Insights", to: "/insights" },
];

export const FOOTER_LINKS = [
  { label: "Systems", to: "/systems" },
  { label: "Technology", to: "/technology" },
  { label: "Company", to: "/company" },
  { label: "Insights", to: "/insights" },
  { label: "Careers", to: "/careers" },
  { label: "Contact", to: "/contact" },
];

export const IMG = {
  globe: "https://static.prod-images.emergentagent.com/jobs/1559ca79-e74b-4e78-b144-4b1084860eb7/images/66352ae72b5773962e2889e292b5fc33f69641aabd57f3defa008bcbd64b0b78.jpeg",
  ring: "https://static.prod-images.emergentagent.com/jobs/1559ca79-e74b-4e78-b144-4b1084860eb7/images/4824f4c36cdec677c21f23464968bdf577eb185fc41e733eeb9a82d3a8fcf22a.jpeg",
  constructons: "https://static.prod-images.emergentagent.com/jobs/1559ca79-e74b-4e78-b144-4b1084860eb7/images/a0c566962145d503530986a2ed1abe8ffc8d7ff6d1b5942f22bd220e7dc186db.jpeg",
  architecture: "https://images.unsplash.com/photo-1483366774565-c783b9f70e2c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  building: "https://images.pexels.com/photos/10974961/pexels-photo-10974961.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  dataTexture: "https://images.unsplash.com/photo-1782338937828-d6c1dab06387?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  office: "https://images.unsplash.com/photo-1758607010203-d6b7f6ec9262?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  constructonsDashboard: "https://static.prod-images.emergentagent.com/jobs/1559ca79-e74b-4e78-b144-4b1084860eb7/images/a9e7a433e19ea35d63b8995cbbd42457d6f06490fa11012137822393d1cd5ab3.jpeg",
  constructonsField: "https://static.prod-images.emergentagent.com/jobs/1559ca79-e74b-4e78-b144-4b1084860eb7/images/e0b7a223462993ca6561710ccfc3619ae392ab2b72bf27b99b12d9151dc1052e.jpeg",
};

export const LOOP_STAGES = [
  { key: "understand", title: "Understand", text: "Capture context, data and objectives." },
  { key: "think", title: "Think", text: "Analyze information and generate intelligence." },
  { key: "decide", title: "Decide", text: "Recommend, prioritize and guide decisions." },
  { key: "execute", title: "Execute", text: "Turn decisions into workflows and actions." },
  { key: "learn", title: "Learn", text: "Capture outcomes and continuously improve." },
];

export const PILLARS = [
  { title: "Intelligence", text: "AI that understands context, not just commands." },
  { title: "Connection", text: "Data, people and workflows connected in one system." },
  { title: "Execution", text: "Intelligence transformed into real-world action." },
  { title: "Evolution", text: "Systems that continuously improve from outcomes." },
];

export const TECH_PILLARS = [
  { tag: "AI-FIRST", text: "Industry-specific AI models and intelligence." },
  { tag: "UNIFIED DATA", text: "A connected data foundation." },
  { tag: "SMART WORKFLOWS", text: "Intelligent automation across operations." },
  { tag: "ENTERPRISE GRADE", text: "Secure, scalable and reliable infrastructure." },
];

export const INDUSTRIES = [
  { name: "Construction", active: true },
  { name: "Manufacturing", active: false },
  { name: "Infrastructure", active: false },
  { name: "Real Estate", active: false },
  { name: "Energy", active: false },
  { name: "Future Industries", active: false },
];

export const CONTACT_REASONS = [
  "General enquiry", "Partnership", "Product", "Enterprise", "Careers", "Media", "Other",
];
